const tableheaders = document.querySelectorAll(".accortion--table ul li");
if ( tableheaders ) {

	for (var i = 0; i < tableheaders.length; i++) {
		tableheaders[i].setAttribute("data-no", i );
		tableheaders[i].onclick = function (e) {
			document.querySelectorAll(".accortion--table tr td:not(.firstcell)").forEach(e => e.setAttribute("style","display:none"));
			document.querySelectorAll(".accortion--table ul li").forEach(e => e.setAttribute("class",""));
			let datano =  this.getAttribute("data-no");
			document.querySelectorAll(".accortion--table tr td[data-no=\"" + datano + "\"]").forEach(e => e.setAttribute("style","display:table-cell"));
			document.querySelectorAll(".accortion--table ul li[data-no=\"" + datano + "\"]").forEach(e => e.setAttribute("class","active"));

		};
	}
	var mediaQuery = window.matchMedia('(min-width: 640px)');
	mediaQuery.addListener(mqTable);
	function mqTable(mediaQuery) {    
		if (mediaQuery.matches) {
			document.querySelectorAll(".accortion--table tr td").forEach(e => e.setAttribute("style","display:table-cell"));
		} else {
			document.querySelectorAll(".accortion--table tr td:not(.firstcell)").forEach(e => e.setAttribute("style","display:none"));
			document.querySelectorAll(".accortion--table tr td[data-no=\"0\"]").forEach(e => e.setAttribute("style","display:table-cell"));
		}
	}
	mqTable(mediaQuery);
}


// WEBPACK FOOTER //
// ./scripts/components/tables.js